import { useTranslation } from 'next-i18next';
import { VFC } from 'react';

import CustomButton from '@/components/CustomButton';
import Notice from '@/components/Notice';
import ProcessResultAlert from '@/components/ProcessResultAlert';
import { GraphToken } from '@/components/SwapWithIPFS/types';

import styles from './TokenTransferApproval.module.scss';

type Props = {
  userTokens: GraphToken[];
  isProcessing: boolean;
  onConfirm(): Promise<void>;
  errorMessage: string | null;
};

const TokenTransferApproval: VFC<Props> = ({
  userTokens,
  isProcessing,
  onConfirm,
  errorMessage,
}: Props) => {
  const { t } = useTranslation();

  const noTokensToSwap = userTokens.length <= 0;

  return (
    <div className={styles.tokenTransferApproval}>
      <h3>{t('swapWithIPFS.swapWithIPFS')}</h3>

      <p>{t('swapWithIPFS.modalContent.description')}</p>

      <p>{t('swapWithIPFS.tokenTransferApproval.message')}</p>

      <Notice>
        <span>{t('swapWithIPFS.modalContent.note')}: </span>
        {t('swapWithIPFS.modalContent.gasFeeNotice')}
      </Notice>

      <CustomButton
        variant="secondary"
        onClick={onConfirm}
        loading={isProcessing}
        disabled={noTokensToSwap}
      >
        {noTokensToSwap
          ? t('swapWithIPFS.tokenTransferApproval.noTokensToSwap')
          : t('swapWithIPFS.modalContent.approveButtonText')}
      </CustomButton>

      {errorMessage && (
        <ProcessResultAlert status="fail" failMessage={errorMessage} />
      )}
    </div>
  );
};

export default TokenTransferApproval;
